// Users, Edit user, Create user, Profile, Entities and Access Denied — the screens' strings in the portal's four
// languages (2026-10-21). Role names, team names and entity codes come from the database and are not in here.
const en = {
  f: {
    username: 'Username',
    firstName: 'First name',
    lastName: 'Last name',
    firstNameCap: 'First Name',
    lastNameCap: 'Last Name',
    email: 'Email',
    emailOptional: 'Email (optional for a partner account)',
    lastNameOptional: 'Last name (optional for a partner account)',
    roles: 'Roles',
    role: 'Role',
    department: 'Department',
    entity: 'Entity',
    partnerCompany: 'Partner company',
    noPartner: '— none (HEVN / Helinox) —',
    active: 'Active',
    inactive: 'Inactive',
    isActive: 'Is Active',
    id: 'ID',
    created: 'Created',
    createdAt: 'Created At',
    ceoDesk: 'CEO Office desk',
    salesRep: 'Sales Rep',
    rolesSelected: '{{n}} selected',
    searchRoles: 'Search roles…',
    noRoles: 'No roles found',
    legacyRole: '{{name}} (legacy)',
  },
  err: {
    required2: 'Username and first name are required.',
    required3: 'Username, first and last name are required.',
    partnerManager: 'A partner company\'s account cannot be a department manager.',
    email: 'Please enter a valid email address.',
    role: 'Select at least one role.',
    updateFailed: 'Failed to update user.',
    emailStar: '*Please enter a valid email address.',
    roleStar: '*Select at least one role.',
    fieldRequired: '*{{field}} is required.',
    usernameLen: '*Username must be between 3 and 50 characters.',
    firstLen: '*First name must be between 2 and 50 characters.',
    lastLen: '*Last name must be between 2 and 50 characters.',
    fetchFailedRetry: 'Failed to fetch user data. Please try again.',
    fetchFailed: 'Failed to fetch user data.',
    emailTaken: '*Email already exists. Please use a different email.',
    usernameTaken: '*Username already exists. Please choose a different username.',
    unexpected: 'An unexpected error occurred. Please try again.',
    noServer: 'Unable to connect to the server. Please try again later.',
    generic: 'An error occurred',
    usernameRequired: '*Username is required.',
    firstMin: '*First name is required (min 2 chars).',
    lastMin: '*Last name is required (min 2 chars).',
  },
  list: {
    title: 'Users',
    back: 'Back',
    accessRequests: 'Access requests',
    entitiesTitle: 'The entities people can be placed in',
    entities: 'Entities',
    createNew: 'Create New User',
    searchPh: 'Search name, username or email…',
    groupBy: 'Group by entity',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    clearFilters: 'Clear filters',
    count: '{{shown}} of {{total}}',
    countInactive: ' · {{n}} inactive (not counted)',
    selected: '{{n}} selected',
    setEntity: 'Set entity',
    bulkAria: 'Entity for the selected people',
    pick: '— pick —',
    noEntityClear: 'No entity (clear)',
    apply: 'Apply',
    saving: 'Saving…',
    clearSelection: 'Clear selection',
    loading: 'Loading…',
    selectAll: 'Select every person shown',
    actions: 'Actions',
    noEntity: 'no entity',
    selectGroup: 'Select everyone in {{name}}',
    expandGroup: 'Expand this group',
    collapseGroup: 'Collapse this group',
    expandNamed: 'Expand {{name}}',
    collapseNamed: 'Collapse {{name}}',
    noEntityYet: 'No entity yet',
    notInUse: '· not in use',
    groupPerson: '{{n}} person',
    groupPeople: '{{n}} people',
    selectUser: 'Select {{name}}',
    partnerTitle: 'A partner company\'s account — {{org}}. It opens that company\'s sample track and nothing else.',
    partnerChip: 'Partner · {{org}}',
    deptManager: '{{team}} · Manager',
    viewProfile: 'View profile',
    edit: 'Edit',
    delete: 'Delete',
    noMatch: 'No users match your filters.',
    showOne: 'Show one',
    bulkMoved: '{{n}} moved to {{where}}.',
    bulkMovedSome: '{{n}} moved to {{where}} · {{m}} already there.',
    bulkFailed: 'Could not save the entity.',
    confirmDelete: 'Delete user "{{name}}"? This cannot be undone.',
  },
  edit: {
    title: 'Edit user',
    none: '— none —',
    notInUseOpt: '(not in use)',
    switchedOff: '(switched off)',
    mainTitle: 'The main department: a new quote is filed under it and the team filters open on it.',
    main: 'Main',
    manager: 'Manager',
    remove: 'Remove {{name}}',
    addDeptAria: 'Add a department',
    addAnother: '+ Add another department',
    addFirst: '+ Add a department',
    noDept: 'No department yet. A person can be in more than one, with Manager ticked for each separately.',
    deskHint: 'Whose tickets this person sees in CEO Office. A desk cannot see the other desk’s tickets at all. They also need a role holding the CEO Office permission.',
    deskNone: 'On no desk: CEO Office shows them nothing, even with the permission.',
    saveChanges: 'Save changes',
    saving: 'Saving…',
    cancel: 'Cancel',
  },
  ent: {
    saved: 'Saved',
    saveFailed: 'Could not save.',
    nameOf: 'Name of {{code}}',
    kindOf: 'Kind of {{code}}',
    inUse: 'In use',
    save: 'Save',
    saving: 'Saving…',
    added: '{{code}} added.',
    addFailed: 'Could not add the entity.',
    title: 'Entities',
    close: 'Close',
    intro: 'The companies and vendors people can be placed in. The user list groups by these. A code cannot change once added; switch an entity off instead of removing it — the people already in it keep it until somebody moves them.',
    colCode: 'Code',
    colName: 'Name',
    colKind: 'Kind',
    colPeople: 'People',
    colPeopleTitle: 'Active accounts in this entity',
    colInUse: 'In use',
    addTitle: 'Add an entity',
    codePh: 'Code, e.g. HKOR',
    namePh: 'Name',
    newCode: 'New entity code',
    newName: 'New entity name',
    newKind: 'New entity kind',
    add: 'Add',
    adding: 'Adding…',
    kindHelinox: 'Helinox',
    kindVendor: 'Vendor',
    kindPartner: 'Partner',
  },
  page: {
    title: 'Edit User',
    loading: 'Loading user data...',
    updated: 'User updated successfully!',
    notSalesRep: '— not a Sales Rep —',
    alreadyLinked: '{{name}} — already linked to {{user}}',
    repSuggest: "This name matches the Sales Rep {{name}}, which is not linked to an account yet.",
    repUse: "Link {{name}}",
    repUsed: "Picked — press Save to link it.",
    salesRepHint: 'Links this login to the Sales Rep on project groups, so their own projects show on the portal home. Give them the “Sales Rep” role too.',
    deskHint: 'Which desk’s tickets this person may see in CEO Office. A desk is access, not a filter: somebody on the Business desk cannot see Executive tickets at all. They also need a role holding the “CEO Office” permission — with no desk ticked, that role shows them an empty section.',
    update: 'UPDATE',
    updating: 'UPDATING...',
  },
  profile: {
    title: 'Profile',
    loading: 'Loading...',
    noData: 'No user data available.',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    sending: 'Sending...',
    sendReset: 'Send Reset Password Email',
  },
  reg: {
    title: 'Create user',
    back: 'Back',
    usernamePh: 'e.g. jane_doe',
    emailPhPartner: 'leave empty if they have none',
    noMailHint: 'No email: no welcome mail can go. The account starts on the password <b>1@</b> and asks for their own at the first sign-in.',
    sendWelcome: 'Send welcome email',
    create: 'Create user',
    creating: 'Creating…',
    cancel: 'Cancel',
    createdNoMail: 'User created with no email. Give {{name}} the password 1@ — they set their own at the first sign-in (Helinox Partner card).',
    createdMailed: 'User created! Welcome email has been sent.',
    created: 'User created!',
    requestNotMarked: '{{msg}} (the request row could not be marked — do it by hand)',
  },
  denied: {
    title: 'Access Denied',
    message: 'You don\'t have permission to view this page.',
    home: '← Back to Home',
    relogin: 'Log In Again',
  },
};

const ko = {
  f: {
    username: '아이디',
    firstName: '이름',
    lastName: '성',
    firstNameCap: '이름',
    lastNameCap: '성',
    email: '이메일',
    emailOptional: '이메일 (파트너 계정은 선택)',
    lastNameOptional: '성 (파트너 계정은 선택)',
    roles: '역할',
    role: '역할',
    department: '부서',
    entity: '법인',
    partnerCompany: '파트너사',
    noPartner: '— 없음 (HEVN / Helinox) —',
    active: '활성',
    inactive: '비활성',
    isActive: '활성 여부',
    id: 'ID',
    created: '생성일',
    createdAt: '생성 일시',
    ceoDesk: 'CEO Office 데스크',
    salesRep: 'Sales Rep',
    rolesSelected: '{{n}}개 선택',
    searchRoles: '역할 검색…',
    noRoles: '역할이 없습니다',
    legacyRole: '{{name}} (이전 역할)',
  },
  err: {
    required2: '아이디와 이름은 필수입니다.',
    required3: '아이디, 이름, 성은 필수입니다.',
    partnerManager: '파트너사 계정은 부서 매니저가 될 수 없습니다.',
    email: '올바른 이메일 주소를 입력하세요.',
    role: '역할을 하나 이상 선택하세요.',
    updateFailed: '사용자를 수정하지 못했습니다.',
    emailStar: '*올바른 이메일 주소를 입력하세요.',
    roleStar: '*역할을 하나 이상 선택하세요.',
    fieldRequired: '*{{field}}은(는) 필수입니다.',
    usernameLen: '*아이디는 3~50자여야 합니다.',
    firstLen: '*이름은 2~50자여야 합니다.',
    lastLen: '*성은 2~50자여야 합니다.',
    fetchFailedRetry: '사용자 정보를 불러오지 못했습니다. 다시 시도하세요.',
    fetchFailed: '사용자 정보를 불러오지 못했습니다.',
    emailTaken: '*이미 사용 중인 이메일입니다. 다른 이메일을 사용하세요.',
    usernameTaken: '*이미 사용 중인 아이디입니다. 다른 아이디를 선택하세요.',
    unexpected: '예기치 않은 오류가 발생했습니다. 다시 시도하세요.',
    noServer: '서버에 연결할 수 없습니다. 잠시 후 다시 시도하세요.',
    generic: '오류가 발생했습니다',
    usernameRequired: '*아이디는 필수입니다.',
    firstMin: '*이름은 필수입니다 (최소 2자).',
    lastMin: '*성은 필수입니다 (최소 2자).',
  },
  list: {
    title: '사용자',
    back: '뒤로',
    accessRequests: '액세스 요청',
    entitiesTitle: '사용자를 배정할 수 있는 법인',
    entities: '법인',
    createNew: '새 사용자 생성',
    searchPh: '이름, 아이디 또는 이메일 검색…',
    groupBy: '법인별 그룹',
    expandAll: '모두 펼치기',
    collapseAll: '모두 접기',
    clearFilters: '필터 해제',
    count: '{{total}}명 중 {{shown}}명',
    countInactive: ' · 비활성 {{n}}명 (집계 제외)',
    selected: '{{n}}명 선택',
    setEntity: '법인 지정',
    bulkAria: '선택한 사용자의 법인',
    pick: '— 선택 —',
    noEntityClear: '법인 없음 (해제)',
    apply: '적용',
    saving: '저장 중…',
    clearSelection: '선택 해제',
    loading: '불러오는 중…',
    selectAll: '표시된 모든 사용자 선택',
    actions: '작업',
    noEntity: '법인 없음',
    selectGroup: '{{name}} 전체 선택',
    expandGroup: '이 그룹 펼치기',
    collapseGroup: '이 그룹 접기',
    expandNamed: '{{name}} 펼치기',
    collapseNamed: '{{name}} 접기',
    noEntityYet: '아직 법인 없음',
    notInUse: '· 사용 안 함',
    groupPerson: '{{n}}명',
    groupPeople: '{{n}}명',
    selectUser: '{{name}} 선택',
    partnerTitle: '파트너사 계정 — {{org}}. 해당 회사의 샘플 트래커만 열 수 있습니다.',
    partnerChip: '파트너 · {{org}}',
    deptManager: '{{team}} · 매니저',
    viewProfile: '프로필 보기',
    edit: '수정',
    delete: '삭제',
    noMatch: '필터에 맞는 사용자가 없습니다.',
    showOne: '하나만 보기',
    bulkMoved: '{{n}}명을 {{where}}(으)로 옮겼습니다.',
    bulkMovedSome: '{{n}}명을 {{where}}(으)로 옮겼습니다 · {{m}}명은 이미 해당 법인입니다.',
    bulkFailed: '법인을 저장하지 못했습니다.',
    confirmDelete: '사용자 "{{name}}"을(를) 삭제하시겠습니까? 되돌릴 수 없습니다.',
  },
  edit: {
    title: '사용자 수정',
    none: '— 없음 —',
    notInUseOpt: '(사용 안 함)',
    switchedOff: '(비활성화됨)',
    mainTitle: '주 부서: 새 견적이 이 부서로 등록되고, 팀 필터도 이 부서로 열립니다.',
    main: '주',
    manager: '매니저',
    remove: '{{name}} 삭제',
    addDeptAria: '부서 추가',
    addAnother: '+ 다른 부서 추가',
    addFirst: '+ 부서 추가',
    noDept: '아직 부서가 없습니다. 한 사람이 여러 부서에 속할 수 있으며, 부서마다 매니저를 따로 체크합니다.',
    deskHint: 'CEO Office에서 이 사람이 볼 수 있는 데스크의 티켓입니다. 한 데스크는 다른 데스크의 티켓을 전혀 볼 수 없습니다. CEO Office 권한이 있는 역할도 필요합니다.',
    deskNone: '데스크 없음: 권한이 있어도 CEO Office에 아무것도 표시되지 않습니다.',
    saveChanges: '변경사항 저장',
    saving: '저장 중…',
    cancel: '취소',
  },
  ent: {
    saved: '저장됨',
    saveFailed: '저장하지 못했습니다.',
    nameOf: '{{code}} 이름',
    kindOf: '{{code}} 구분',
    inUse: '사용',
    save: '저장',
    saving: '저장 중…',
    added: '{{code}}을(를) 추가했습니다.',
    addFailed: '법인을 추가하지 못했습니다.',
    title: '법인',
    close: '닫기',
    intro: '사용자를 배정할 수 있는 회사와 벤더입니다. 사용자 목록은 이 기준으로 그룹화됩니다. 코드는 추가한 뒤 바꿀 수 없습니다. 법인을 삭제하는 대신 사용을 해제하세요 — 이미 속한 사용자는 누군가 옮길 때까지 그대로 유지됩니다.',
    colCode: '코드',
    colName: '이름',
    colKind: '구분',
    colPeople: '인원',
    colPeopleTitle: '이 법인의 활성 계정',
    colInUse: '사용',
    addTitle: '법인 추가',
    codePh: '코드, 예: HKOR',
    namePh: '이름',
    newCode: '새 법인 코드',
    newName: '새 법인 이름',
    newKind: '새 법인 구분',
    add: '추가',
    adding: '추가 중…',
    kindHelinox: 'Helinox',
    kindVendor: '벤더',
    kindPartner: '파트너',
  },
  page: {
    title: '사용자 수정',
    loading: '사용자 정보를 불러오는 중...',
    updated: '사용자 정보가 수정되었습니다!',
    notSalesRep: '— Sales Rep 아님 —',
    alreadyLinked: '{{name}} — 이미 {{user}}에 연결됨',
    repSuggest: "이 이름은 아직 계정에 연결되지 않은 Sales Rep {{name}}과(와) 일치합니다.",
    repUse: "{{name}} 연결",
    repUsed: "선택했습니다 — 저장을 눌러야 연결됩니다.",
    salesRepHint: '이 로그인을 프로젝트 그룹의 Sales Rep과 연결하여, 본인 프로젝트가 포털 홈에 표시되게 합니다. “Sales Rep” 역할도 함께 부여하세요.',
    deskHint: 'CEO Office에서 이 사람이 볼 수 있는 데스크의 티켓입니다. 데스크는 필터가 아니라 접근 권한입니다: Business 데스크 사람은 Executive 티켓을 전혀 볼 수 없습니다. “CEO Office” 권한이 있는 역할도 필요하며, 데스크를 체크하지 않으면 그 역할로도 빈 화면만 보입니다.',
    update: '수정',
    updating: '수정 중...',
  },
  profile: {
    title: '프로필',
    loading: '불러오는 중...',
    noData: '사용자 정보가 없습니다.',
    yes: '예',
    no: '아니오',
    back: '뒤로',
    sending: '보내는 중...',
    sendReset: '비밀번호 재설정 메일 보내기',
  },
  reg: {
    title: '사용자 생성',
    back: '뒤로',
    usernamePh: '예: jane_doe',
    emailPhPartner: '없으면 비워 두세요',
    noMailHint: '이메일 없음: 환영 메일을 보낼 수 없습니다. 계정은 비밀번호 <b>1@</b>로 시작하며, 첫 로그인 때 본인 비밀번호를 설정하게 됩니다.',
    sendWelcome: '환영 메일 보내기',
    create: '사용자 생성',
    creating: '생성 중…',
    cancel: '취소',
    createdNoMail: '이메일 없이 사용자를 생성했습니다. {{name}}에게 비밀번호 1@를 알려 주세요 — 첫 로그인 때 본인 비밀번호를 설정합니다 (Helinox Partner 카드).',
    createdMailed: '사용자를 생성했습니다! 환영 메일을 보냈습니다.',
    created: '사용자를 생성했습니다!',
    requestNotMarked: '{{msg}} (요청 행을 처리 완료로 표시하지 못했습니다 — 직접 표시하세요)',
  },
  denied: {
    title: '접근 거부',
    message: '이 페이지를 볼 권한이 없습니다.',
    home: '← 홈으로',
    relogin: '다시 로그인',
  },
};

const vi = {
  f: {
    username: 'Tên đăng nhập',
    firstName: 'Tên',
    lastName: 'Họ',
    firstNameCap: 'Tên',
    lastNameCap: 'Họ',
    email: 'Email',
    emailOptional: 'Email (không bắt buộc với tài khoản đối tác)',
    lastNameOptional: 'Họ (không bắt buộc với tài khoản đối tác)',
    roles: 'Vai trò',
    role: 'Vai trò',
    department: 'Bộ phận',
    entity: 'Pháp nhân',
    partnerCompany: 'Công ty đối tác',
    noPartner: '— không có (HEVN / Helinox) —',
    active: 'Đang hoạt động',
    inactive: 'Ngừng hoạt động',
    isActive: 'Đang hoạt động',
    id: 'ID',
    created: 'Ngày tạo',
    createdAt: 'Ngày tạo',
    ceoDesk: 'Nhóm Văn phòng CEO',
    salesRep: 'Sales Rep',
    rolesSelected: 'Đã chọn {{n}}',
    searchRoles: 'Tìm vai trò…',
    noRoles: 'Không tìm thấy vai trò',
    legacyRole: '{{name}} (vai trò cũ)',
  },
  err: {
    required2: 'Bắt buộc nhập tên đăng nhập và tên.',
    required3: 'Bắt buộc nhập tên đăng nhập, tên và họ.',
    partnerManager: 'Tài khoản của công ty đối tác không thể là quản lý bộ phận.',
    email: 'Vui lòng nhập địa chỉ email hợp lệ.',
    role: 'Chọn ít nhất một vai trò.',
    updateFailed: 'Không cập nhật được người dùng.',
    emailStar: '*Vui lòng nhập địa chỉ email hợp lệ.',
    roleStar: '*Chọn ít nhất một vai trò.',
    fieldRequired: '*Bắt buộc nhập {{field}}.',
    usernameLen: '*Tên đăng nhập phải từ 3 đến 50 ký tự.',
    firstLen: '*Tên phải từ 2 đến 50 ký tự.',
    lastLen: '*Họ phải từ 2 đến 50 ký tự.',
    fetchFailedRetry: 'Không tải được dữ liệu người dùng. Vui lòng thử lại.',
    fetchFailed: 'Không tải được dữ liệu người dùng.',
    emailTaken: '*Email đã tồn tại. Vui lòng dùng email khác.',
    usernameTaken: '*Tên đăng nhập đã tồn tại. Vui lòng chọn tên khác.',
    unexpected: 'Đã xảy ra lỗi không mong muốn. Vui lòng thử lại.',
    noServer: 'Không kết nối được máy chủ. Vui lòng thử lại sau.',
    generic: 'Đã xảy ra lỗi',
    usernameRequired: '*Bắt buộc nhập tên đăng nhập.',
    firstMin: '*Bắt buộc nhập tên (tối thiểu 2 ký tự).',
    lastMin: '*Bắt buộc nhập họ (tối thiểu 2 ký tự).',
  },
  list: {
    title: 'Người dùng',
    back: 'Quay lại',
    accessRequests: 'Yêu cầu truy cập',
    entitiesTitle: 'Các pháp nhân có thể gán cho người dùng',
    entities: 'Pháp nhân',
    createNew: 'Tạo người dùng mới',
    searchPh: 'Tìm theo tên, tên đăng nhập hoặc email…',
    groupBy: 'Nhóm theo pháp nhân',
    expandAll: 'Mở tất cả',
    collapseAll: 'Thu gọn tất cả',
    clearFilters: 'Xóa bộ lọc',
    count: '{{shown}} / {{total}}',
    countInactive: ' · {{n}} không hoạt động (không tính)',
    selected: 'Đã chọn {{n}} người',
    setEntity: 'Gán pháp nhân',
    bulkAria: 'Pháp nhân cho những người đã chọn',
    pick: '— chọn —',
    noEntityClear: 'Không có pháp nhân (xóa)',
    apply: 'Áp dụng',
    saving: 'Đang lưu…',
    clearSelection: 'Bỏ chọn',
    loading: 'Đang tải…',
    selectAll: 'Chọn tất cả người đang hiển thị',
    actions: 'Thao tác',
    noEntity: 'chưa có pháp nhân',
    selectGroup: 'Chọn tất cả trong {{name}}',
    expandGroup: 'Mở nhóm này',
    collapseGroup: 'Thu gọn nhóm này',
    expandNamed: 'Mở {{name}}',
    collapseNamed: 'Thu gọn {{name}}',
    noEntityYet: 'Chưa có pháp nhân',
    notInUse: '· ngừng sử dụng',
    groupPerson: '{{n}} người',
    groupPeople: '{{n}} người',
    selectUser: 'Chọn {{name}}',
    partnerTitle: 'Tài khoản của công ty đối tác — {{org}}. Tài khoản này chỉ mở được mục theo dõi mẫu của công ty đó.',
    partnerChip: 'Đối tác · {{org}}',
    deptManager: '{{team}} · Quản lý',
    viewProfile: 'Xem hồ sơ',
    edit: 'Sửa',
    delete: 'Xóa',
    noMatch: 'Không có người dùng nào khớp với bộ lọc.',
    showOne: 'Chỉ hiện một',
    bulkMoved: 'Đã chuyển {{n}} người sang {{where}}.',
    bulkMovedSome: 'Đã chuyển {{n}} người sang {{where}} · {{m}} người đã ở đó.',
    bulkFailed: 'Không lưu được pháp nhân.',
    confirmDelete: 'Xóa người dùng "{{name}}"? Không thể hoàn tác.',
  },
  edit: {
    title: 'Sửa người dùng',
    none: '— không có —',
    notInUseOpt: '(ngừng sử dụng)',
    switchedOff: '(đã tắt)',
    mainTitle: 'Bộ phận chính: báo giá mới được lưu theo bộ phận này và bộ lọc nhóm mở theo bộ phận này.',
    main: 'Chính',
    manager: 'Quản lý',
    remove: 'Gỡ {{name}}',
    addDeptAria: 'Thêm bộ phận',
    addAnother: '+ Thêm bộ phận khác',
    addFirst: '+ Thêm bộ phận',
    noDept: 'Chưa có bộ phận. Một người có thể thuộc nhiều bộ phận, mỗi bộ phận đánh dấu Quản lý riêng.',
    deskHint: 'Người này thấy ticket của nhóm nào trong Văn phòng CEO. Một nhóm hoàn toàn không thấy ticket của nhóm kia. Họ cũng cần một vai trò có quyền CEO Office.',
    deskNone: 'Không thuộc nhóm nào: Văn phòng CEO không hiển thị gì, kể cả khi có quyền.',
    saveChanges: 'Lưu thay đổi',
    saving: 'Đang lưu…',
    cancel: 'Hủy',
  },
  ent: {
    saved: 'Đã lưu',
    saveFailed: 'Không lưu được.',
    nameOf: 'Tên của {{code}}',
    kindOf: 'Loại của {{code}}',
    inUse: 'Đang dùng',
    save: 'Lưu',
    saving: 'Đang lưu…',
    added: 'Đã thêm {{code}}.',
    addFailed: 'Không thêm được pháp nhân.',
    title: 'Pháp nhân',
    close: 'Đóng',
    intro: 'Các công ty và nhà cung cấp có thể gán cho người dùng. Danh sách người dùng được nhóm theo các mục này. Mã không thể đổi sau khi thêm; hãy tắt pháp nhân thay vì xóa — những người đã thuộc pháp nhân đó vẫn giữ nguyên cho đến khi có người chuyển họ.',
    colCode: 'Mã',
    colName: 'Tên',
    colKind: 'Loại',
    colPeople: 'Số người',
    colPeopleTitle: 'Các tài khoản đang hoạt động trong pháp nhân này',
    colInUse: 'Đang dùng',
    addTitle: 'Thêm pháp nhân',
    codePh: 'Mã, ví dụ HKOR',
    namePh: 'Tên',
    newCode: 'Mã pháp nhân mới',
    newName: 'Tên pháp nhân mới',
    newKind: 'Loại pháp nhân mới',
    add: 'Thêm',
    adding: 'Đang thêm…',
    kindHelinox: 'Helinox',
    kindVendor: 'Nhà cung cấp',
    kindPartner: 'Đối tác',
  },
  page: {
    title: 'Sửa người dùng',
    loading: 'Đang tải dữ liệu người dùng...',
    updated: 'Đã cập nhật người dùng!',
    notSalesRep: '— không phải Sales Rep —',
    alreadyLinked: '{{name}} — đã liên kết với {{user}}',
    repSuggest: "Tên này khớp với Sales Rep {{name}}, chưa được nối với tài khoản nào.",
    repUse: "Nối {{name}}",
    repUsed: "Đã chọn — bấm Save để nối.",
    salesRepHint: 'Liên kết tài khoản đăng nhập này với Sales Rep trên các nhóm dự án, để dự án của họ hiện trên trang chủ portal. Hãy cấp thêm vai trò “Sales Rep”.',
    deskHint: 'Người này được xem ticket của nhóm nào trong Văn phòng CEO. Nhóm là quyền truy cập, không phải bộ lọc: người thuộc nhóm Business hoàn toàn không thấy ticket Executive. Họ cũng cần một vai trò có quyền “CEO Office” — nếu không đánh dấu nhóm nào, vai trò đó chỉ hiện một mục trống.',
    update: 'CẬP NHẬT',
    updating: 'ĐANG CẬP NHẬT...',
  },
  profile: {
    title: 'Hồ sơ',
    loading: 'Đang tải...',
    noData: 'Không có dữ liệu người dùng.',
    yes: 'Có',
    no: 'Không',
    back: 'Quay lại',
    sending: 'Đang gửi...',
    sendReset: 'Gửi email đặt lại mật khẩu',
  },
  reg: {
    title: 'Tạo người dùng',
    back: 'Quay lại',
    usernamePh: 'ví dụ jane_doe',
    emailPhPartner: 'để trống nếu họ không có',
    noMailHint: 'Không có email: không gửi được email chào mừng. Tài khoản bắt đầu với mật khẩu <b>1@</b> và sẽ yêu cầu đặt mật khẩu riêng ở lần đăng nhập đầu tiên.',
    sendWelcome: 'Gửi email chào mừng',
    create: 'Tạo người dùng',
    creating: 'Đang tạo…',
    cancel: 'Hủy',
    createdNoMail: 'Đã tạo người dùng không có email. Hãy đưa cho {{name}} mật khẩu 1@ — họ sẽ tự đặt mật khẩu ở lần đăng nhập đầu tiên (thẻ Helinox Partner).',
    createdMailed: 'Đã tạo người dùng! Email chào mừng đã được gửi.',
    created: 'Đã tạo người dùng!',
    requestNotMarked: '{{msg}} (không đánh dấu được yêu cầu — hãy đánh dấu thủ công)',
  },
  denied: {
    title: 'Truy cập bị từ chối',
    message: 'Bạn không có quyền xem trang này.',
    home: '← Về trang chủ',
    relogin: 'Đăng nhập lại',
  },
};

const zh = {
  f: {
    username: '用户名',
    firstName: '名',
    lastName: '姓',
    firstNameCap: '名',
    lastNameCap: '姓',
    email: '邮箱',
    emailOptional: '邮箱（合作伙伴账户可不填）',
    lastNameOptional: '姓（合作伙伴账户可不填）',
    roles: '角色',
    role: '角色',
    department: '部门',
    entity: '法人实体',
    partnerCompany: '合作伙伴公司',
    noPartner: '— 无（HEVN / Helinox）—',
    active: '启用',
    inactive: '停用',
    isActive: '是否启用',
    id: 'ID',
    created: '创建时间',
    createdAt: '创建时间',
    ceoDesk: 'CEO 办公室工作组',
    salesRep: '销售代表',
    rolesSelected: '已选 {{n}} 个',
    searchRoles: '搜索角色…',
    noRoles: '未找到角色',
    legacyRole: '{{name}}（旧角色）',
  },
  err: {
    required2: '用户名和名为必填项。',
    required3: '用户名、名和姓为必填项。',
    partnerManager: '合作伙伴公司的账户不能担任部门经理。',
    email: '请输入有效的邮箱地址。',
    role: '请至少选择一个角色。',
    updateFailed: '更新用户失败。',
    emailStar: '*请输入有效的邮箱地址。',
    roleStar: '*请至少选择一个角色。',
    fieldRequired: '*{{field}}为必填项。',
    usernameLen: '*用户名长度须为 3 到 50 个字符。',
    firstLen: '*名的长度须为 2 到 50 个字符。',
    lastLen: '*姓的长度须为 2 到 50 个字符。',
    fetchFailedRetry: '无法加载用户数据，请重试。',
    fetchFailed: '无法加载用户数据。',
    emailTaken: '*该邮箱已存在，请使用其他邮箱。',
    usernameTaken: '*该用户名已存在，请选择其他用户名。',
    unexpected: '发生意外错误，请重试。',
    noServer: '无法连接服务器，请稍后再试。',
    generic: '发生错误',
    usernameRequired: '*用户名为必填项。',
    firstMin: '*名为必填项（至少 2 个字符）。',
    lastMin: '*姓为必填项（至少 2 个字符）。',
  },
  list: {
    title: '用户',
    back: '返回',
    accessRequests: '访问申请',
    entitiesTitle: '可分配给用户的法人实体',
    entities: '法人实体',
    createNew: '创建新用户',
    searchPh: '搜索姓名、用户名或邮箱…',
    groupBy: '按法人实体分组',
    expandAll: '全部展开',
    collapseAll: '全部收起',
    clearFilters: '清除筛选',
    count: '{{shown}} / {{total}}',
    countInactive: ' · {{n}} 个停用（不计入）',
    selected: '已选 {{n}} 人',
    setEntity: '设置法人实体',
    bulkAria: '所选人员的法人实体',
    pick: '— 请选择 —',
    noEntityClear: '无法人实体（清除）',
    apply: '应用',
    saving: '保存中…',
    clearSelection: '取消选择',
    loading: '加载中…',
    selectAll: '选择所有显示的人员',
    actions: '操作',
    noEntity: '无法人实体',
    selectGroup: '选择 {{name}} 中的所有人',
    expandGroup: '展开此分组',
    collapseGroup: '收起此分组',
    expandNamed: '展开 {{name}}',
    collapseNamed: '收起 {{name}}',
    noEntityYet: '尚无法人实体',
    notInUse: '· 已停用',
    groupPerson: '{{n}} 人',
    groupPeople: '{{n}} 人',
    selectUser: '选择 {{name}}',
    partnerTitle: '合作伙伴公司的账户 — {{org}}。只能打开该公司的样品跟踪，无法访问其他内容。',
    partnerChip: '合作伙伴 · {{org}}',
    deptManager: '{{team}} · 经理',
    viewProfile: '查看个人资料',
    edit: '编辑',
    delete: '删除',
    noMatch: '没有符合筛选条件的用户。',
    showOne: '只显示一个',
    bulkMoved: '已将 {{n}} 人移至 {{where}}。',
    bulkMovedSome: '已将 {{n}} 人移至 {{where}} · {{m}} 人已在其中。',
    bulkFailed: '无法保存法人实体。',
    confirmDelete: '删除用户“{{name}}”？此操作无法撤销。',
  },
  edit: {
    title: '编辑用户',
    none: '— 无 —',
    notInUseOpt: '（已停用）',
    switchedOff: '（已关闭）',
    mainTitle: '主部门：新报价归入该部门，团队筛选也默认打开该部门。',
    main: '主',
    manager: '经理',
    remove: '移除 {{name}}',
    addDeptAria: '添加部门',
    addAnother: '+ 添加其他部门',
    addFirst: '+ 添加部门',
    noDept: '尚无部门。一个人可以属于多个部门，每个部门分别勾选经理。',
    deskHint: '此人在 CEO 办公室中可查看哪个工作组的工单。一个工作组完全看不到另一个工作组的工单。此人还需要拥有 CEO Office 权限的角色。',
    deskNone: '未加入任何工作组：即使有权限，CEO 办公室也不会显示任何内容。',
    saveChanges: '保存更改',
    saving: '保存中…',
    cancel: '取消',
  },
  ent: {
    saved: '已保存',
    saveFailed: '保存失败。',
    nameOf: '{{code}} 的名称',
    kindOf: '{{code}} 的类型',
    inUse: '启用',
    save: '保存',
    saving: '保存中…',
    added: '已添加 {{code}}。',
    addFailed: '无法添加法人实体。',
    title: '法人实体',
    close: '关闭',
    intro: '可分配给用户的公司和供应商。用户列表按此分组。代码添加后不可更改；请停用法人实体而不是删除 — 已在其中的人员会保留，直到有人将其移走。',
    colCode: '代码',
    colName: '名称',
    colKind: '类型',
    colPeople: '人数',
    colPeopleTitle: '该法人实体中的启用账户',
    colInUse: '启用',
    addTitle: '添加法人实体',
    codePh: '代码，例如 HKOR',
    namePh: '名称',
    newCode: '新法人实体代码',
    newName: '新法人实体名称',
    newKind: '新法人实体类型',
    add: '添加',
    adding: '添加中…',
    kindHelinox: 'Helinox',
    kindVendor: '供应商',
    kindPartner: '合作伙伴',
  },
  page: {
    title: '编辑用户',
    loading: '正在加载用户数据...',
    updated: '用户已更新！',
    notSalesRep: '— 非销售代表 —',
    alreadyLinked: '{{name}} — 已关联到 {{user}}',
    repSuggest: "此姓名与尚未关联账户的销售代表 {{name}} 一致。",
    repUse: "关联 {{name}}",
    repUsed: "已选择 — 点击保存后才会关联。",
    salesRepHint: '将此登录账户与项目组中的销售代表关联，使其本人的项目显示在门户首页。请同时授予“Sales Rep”角色。',
    deskHint: '此人可在 CEO 办公室查看哪个工作组的工单。工作组是访问权限而不是筛选：Business 工作组的人完全看不到 Executive 工单。此人还需要拥有“CEO Office”权限的角色——如果未勾选任何工作组，该角色只会显示空白页面。',
    update: '更新',
    updating: '更新中...',
  },
  profile: {
    title: '个人资料',
    loading: '加载中...',
    noData: '暂无用户数据。',
    yes: '是',
    no: '否',
    back: '返回',
    sending: '发送中...',
    sendReset: '发送重置密码邮件',
  },
  reg: {
    title: '创建用户',
    back: '返回',
    usernamePh: '例如 jane_doe',
    emailPhPartner: '如没有可留空',
    noMailHint: '无邮箱：无法发送欢迎邮件。账户初始密码为 <b>1@</b>，首次登录时会要求设置自己的密码。',
    sendWelcome: '发送欢迎邮件',
    create: '创建用户',
    creating: '创建中…',
    cancel: '取消',
    createdNoMail: '已创建无邮箱的用户。请将密码 1@ 告知 {{name}} — 首次登录时由其设置自己的密码（Helinox Partner 卡片）。',
    createdMailed: '用户已创建！欢迎邮件已发送。',
    created: '用户已创建！',
    requestNotMarked: '{{msg}}（无法标记该申请行 — 请手动处理）',
  },
  denied: {
    title: '拒绝访问',
    message: '您没有查看此页面的权限。',
    home: '← 返回首页',
    relogin: '重新登录',
  },
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "f": {
    "username": "Nom d'utilisateur",
    "firstName": "Prénom",
    "lastName": "Nom",
    "firstNameCap": "Prénom",
    "lastNameCap": "Nom",
    "email": "E-mail",
    "emailOptional": "E-mail (facultatif pour un compte partenaire)",
    "lastNameOptional": "Nom (facultatif pour un compte partenaire)",
    "roles": "Rôles",
    "role": "Rôle",
    "department": "Département",
    "entity": "Entité",
    "partnerCompany": "Société partenaire",
    "noPartner": "— aucune (HEVN / Helinox) —",
    "active": "Actif",
    "inactive": "Inactif",
    "isActive": "Actif",
    "id": "ID",
    "created": "Créé",
    "createdAt": "Créé le",
    "ceoDesk": "Desk CEO Office",
    "salesRep": "Commercial",
    "rolesSelected": "{{n}} sélectionnés",
    "searchRoles": "Rechercher des rôles…",
    "noRoles": "Aucun rôle trouvé",
    "legacyRole": "{{name}} (ancien)"
  },
  "err": {
    "required2": "Le nom d'utilisateur et le prénom sont obligatoires.",
    "required3": "Le nom d'utilisateur, le prénom et le nom sont obligatoires.",
    "partnerManager": "Le compte d'une société partenaire ne peut pas être responsable de département.",
    "email": "Veuillez saisir une adresse e-mail valide.",
    "role": "Sélectionnez au moins un rôle.",
    "updateFailed": "Échec de la mise à jour de l'utilisateur.",
    "emailStar": "*Veuillez saisir une adresse e-mail valide.",
    "roleStar": "*Sélectionnez au moins un rôle.",
    "fieldRequired": "*{{field}} est obligatoire.",
    "usernameLen": "*Le nom d'utilisateur doit comporter entre 3 et 50 caractères.",
    "firstLen": "*Le prénom doit comporter entre 2 et 50 caractères.",
    "lastLen": "*Le nom doit comporter entre 2 et 50 caractères.",
    "fetchFailedRetry": "Impossible de récupérer les données de l'utilisateur. Veuillez réessayer.",
    "fetchFailed": "Impossible de récupérer les données de l'utilisateur.",
    "emailTaken": "*Cet e-mail existe déjà. Veuillez en utiliser un autre.",
    "usernameTaken": "*Ce nom d'utilisateur existe déjà. Veuillez en choisir un autre.",
    "unexpected": "Une erreur inattendue s'est produite. Veuillez réessayer.",
    "noServer": "Impossible de se connecter au serveur. Veuillez réessayer plus tard.",
    "generic": "Une erreur s'est produite",
    "usernameRequired": "*Le nom d'utilisateur est obligatoire.",
    "firstMin": "*Le prénom est obligatoire (2 caractères minimum).",
    "lastMin": "*Le nom est obligatoire (2 caractères minimum)."
  },
  "list": {
    "title": "Utilisateurs",
    "back": "Retour",
    "accessRequests": "Demandes d'accès",
    "entitiesTitle": "Les entités dans lesquelles les personnes peuvent être placées",
    "entities": "Entités",
    "createNew": "Créer un utilisateur",
    "searchPh": "Rechercher un nom, un identifiant ou un e-mail…",
    "groupBy": "Grouper par entité",
    "expandAll": "Tout développer",
    "collapseAll": "Tout réduire",
    "clearFilters": "Effacer les filtres",
    "count": "{{shown}} sur {{total}}",
    "countInactive": " · {{n}} inactifs (non comptés)",
    "selected": "{{n}} sélectionnés",
    "setEntity": "Définir l'entité",
    "bulkAria": "Entité des personnes sélectionnées",
    "pick": "— choisir —",
    "noEntityClear": "Aucune entité (effacer)",
    "apply": "Appliquer",
    "saving": "Enregistrement…",
    "clearSelection": "Effacer la sélection",
    "loading": "Chargement…",
    "selectAll": "Sélectionner toutes les personnes affichées",
    "actions": "Actions",
    "noEntity": "aucune entité",
    "selectGroup": "Sélectionner tout le monde dans {{name}}",
    "expandGroup": "Développer ce groupe",
    "collapseGroup": "Réduire ce groupe",
    "expandNamed": "Développer {{name}}",
    "collapseNamed": "Réduire {{name}}",
    "noEntityYet": "Pas encore d'entité",
    "notInUse": "· inutilisée",
    "groupPerson": "{{n}} personne",
    "groupPeople": "{{n}} personnes",
    "selectUser": "Sélectionner {{name}}",
    "partnerTitle": "Compte d'une société partenaire — {{org}}. Il ouvre uniquement le suivi des échantillons de cette société.",
    "partnerChip": "Partenaire · {{org}}",
    "deptManager": "{{team}} · Responsable",
    "viewProfile": "Voir le profil",
    "edit": "Modifier",
    "delete": "Supprimer",
    "noMatch": "Aucun utilisateur ne correspond à vos filtres.",
    "showOne": "En afficher un",
    "bulkMoved": "{{n}} déplacés vers {{where}}.",
    "bulkMovedSome": "{{n}} déplacés vers {{where}} · {{m}} y étaient déjà.",
    "bulkFailed": "Impossible d'enregistrer l'entité.",
    "confirmDelete": "Supprimer l'utilisateur « {{name}} » ? Cette action est irréversible."
  },
  "edit": {
    "title": "Modifier l'utilisateur",
    "none": "— aucun —",
    "notInUseOpt": "(inutilisé)",
    "switchedOff": "(désactivé)",
    "mainTitle": "Le département principal : un nouveau devis y est classé et les filtres d'équipe s'ouvrent dessus.",
    "main": "Principal",
    "manager": "Responsable",
    "remove": "Retirer {{name}}",
    "addDeptAria": "Ajouter un département",
    "addAnother": "+ Ajouter un autre département",
    "addFirst": "+ Ajouter un département",
    "noDept": "Pas encore de département. Une personne peut appartenir à plusieurs départements, avec Responsable coché séparément pour chacun.",
    "deskHint": "De quel desk cette personne voit les tickets dans CEO Office. Un desk ne voit pas du tout les tickets de l'autre desk. Elle a aussi besoin d'un rôle comportant la permission CEO Office.",
    "deskNone": "Sur aucun desk : CEO Office ne lui montre rien, même avec la permission.",
    "saveChanges": "Enregistrer les modifications",
    "saving": "Enregistrement…",
    "cancel": "Annuler"
  },
  "ent": {
    "saved": "Enregistré",
    "saveFailed": "Impossible d'enregistrer.",
    "nameOf": "Nom de {{code}}",
    "kindOf": "Type de {{code}}",
    "inUse": "Utilisée",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "added": "{{code}} ajoutée.",
    "addFailed": "Impossible d'ajouter l'entité.",
    "title": "Entités",
    "close": "Fermer",
    "intro": "Les sociétés et fournisseurs dans lesquels les personnes peuvent être placées. La liste des utilisateurs est groupée selon ces entités. Un code ne peut plus être modifié une fois ajouté ; désactivez une entité au lieu de la supprimer — les personnes qui s'y trouvent la conservent tant que personne ne les déplace.",
    "colCode": "Code",
    "colName": "Nom",
    "colKind": "Type",
    "colPeople": "Personnes",
    "colPeopleTitle": "Comptes actifs dans cette entité",
    "colInUse": "Utilisée",
    "addTitle": "Ajouter une entité",
    "codePh": "Code, p. ex. HKOR",
    "namePh": "Nom",
    "newCode": "Code de la nouvelle entité",
    "newName": "Nom de la nouvelle entité",
    "newKind": "Type de la nouvelle entité",
    "add": "Ajouter",
    "adding": "Ajout…",
    "kindHelinox": "Helinox",
    "kindVendor": "Fournisseur",
    "kindPartner": "Partenaire"
  },
  "page": {
    "title": "Modifier l'utilisateur",
    "loading": "Chargement des données de l'utilisateur...",
    "updated": "Utilisateur mis à jour avec succès !",
    "notSalesRep": "— pas un Sales Rep —",
    "alreadyLinked": "{{name}} — déjà lié à {{user}}",
    "repSuggest": "Ce nom correspond au Sales Rep {{name}}, qui n'est pas encore lié à un compte.",
    "repUse": "Lier {{name}}",
    "repUsed": "Sélectionné — cliquez sur Enregistrer pour le lier.",
    "salesRepHint": "Lie cet identifiant au Sales Rep des groupes de projets, afin que ses propres projets apparaissent sur l'accueil du portail. Donnez-lui aussi le rôle « Sales Rep ».",
    "deskHint": "De quel desk cette personne peut voir les tickets dans CEO Office. Un desk est un accès, pas un filtre : quelqu'un du desk Business ne voit pas du tout les tickets Executive. Elle a aussi besoin d'un rôle comportant la permission « CEO Office » — sans desk coché, ce rôle lui montre une section vide.",
    "update": "METTRE À JOUR",
    "updating": "MISE À JOUR..."
  },
  "profile": {
    "title": "Profil",
    "loading": "Chargement...",
    "noData": "Aucune donnée utilisateur disponible.",
    "yes": "Oui",
    "no": "Non",
    "back": "Retour",
    "sending": "Envoi...",
    "sendReset": "Envoyer l'e-mail de réinitialisation du mot de passe"
  },
  "reg": {
    "title": "Créer un utilisateur",
    "back": "Retour",
    "usernamePh": "p. ex. jane_doe",
    "emailPhPartner": "laissez vide s'il n'en a pas",
    "noMailHint": "Pas d'e-mail : aucun e-mail de bienvenue ne peut être envoyé. Le compte démarre avec le mot de passe <b>1@</b> et demande d'en choisir un à la première connexion.",
    "sendWelcome": "Envoyer l'e-mail de bienvenue",
    "create": "Créer l'utilisateur",
    "creating": "Création…",
    "cancel": "Annuler",
    "createdNoMail": "Utilisateur créé sans e-mail. Donnez à {{name}} le mot de passe 1@ — la personne choisira le sien à la première connexion (carte Helinox Partner).",
    "createdMailed": "Utilisateur créé ! L'e-mail de bienvenue a été envoyé.",
    "created": "Utilisateur créé !",
    "requestNotMarked": "{{msg}} (la ligne de demande n'a pas pu être marquée — faites-le à la main)"
  },
  "denied": {
    "title": "Accès refusé",
    "message": "Vous n'avez pas l'autorisation de consulter cette page.",
    "home": "← Retour à l'accueil",
    "relogin": "Se reconnecter"
  }
};
const ja = {
  "f": {
    "username": "ユーザー名",
    "firstName": "名",
    "lastName": "姓",
    "firstNameCap": "名",
    "lastNameCap": "姓",
    "email": "メール",
    "emailOptional": "メール（パートナーアカウントは任意）",
    "lastNameOptional": "姓（パートナーアカウントは任意）",
    "roles": "ロール",
    "role": "ロール",
    "department": "部門",
    "entity": "エンティティ",
    "partnerCompany": "パートナー会社",
    "noPartner": "— なし (HEVN / Helinox) —",
    "active": "有効",
    "inactive": "無効",
    "isActive": "有効",
    "id": "ID",
    "created": "作成",
    "createdAt": "作成日時",
    "ceoDesk": "CEO Office デスク",
    "salesRep": "営業担当",
    "rolesSelected": "{{n}} 件選択中",
    "searchRoles": "ロールを検索…",
    "noRoles": "ロールが見つかりません",
    "legacyRole": "{{name}}（旧）"
  },
  "err": {
    "required2": "ユーザー名と名は必須です。",
    "required3": "ユーザー名、名、姓は必須です。",
    "partnerManager": "パートナー会社のアカウントは部門マネージャーにできません。",
    "email": "有効なメールアドレスを入力してください。",
    "role": "ロールを1つ以上選択してください。",
    "updateFailed": "ユーザーの更新に失敗しました。",
    "emailStar": "*有効なメールアドレスを入力してください。",
    "roleStar": "*ロールを1つ以上選択してください。",
    "fieldRequired": "*{{field}} は必須です。",
    "usernameLen": "*ユーザー名は3〜50文字で入力してください。",
    "firstLen": "*名は2〜50文字で入力してください。",
    "lastLen": "*姓は2〜50文字で入力してください。",
    "fetchFailedRetry": "ユーザーデータを取得できませんでした。もう一度お試しください。",
    "fetchFailed": "ユーザーデータを取得できませんでした。",
    "emailTaken": "*このメールアドレスはすでに登録されています。別のメールアドレスを使用してください。",
    "usernameTaken": "*このユーザー名はすでに使われています。別のユーザー名を選んでください。",
    "unexpected": "予期しないエラーが発生しました。もう一度お試しください。",
    "noServer": "サーバーに接続できません。しばらくしてからもう一度お試しください。",
    "generic": "エラーが発生しました",
    "usernameRequired": "*ユーザー名は必須です。",
    "firstMin": "*名は必須です（2文字以上）。",
    "lastMin": "*姓は必須です（2文字以上）。"
  },
  "list": {
    "title": "ユーザー",
    "back": "戻る",
    "accessRequests": "アクセス申請",
    "entitiesTitle": "ユーザーを所属させられるエンティティ",
    "entities": "エンティティ",
    "createNew": "新規ユーザーを作成",
    "searchPh": "名前、ユーザー名、メールアドレスで検索…",
    "groupBy": "エンティティ別にグループ化",
    "expandAll": "すべて展開",
    "collapseAll": "すべて折りたたむ",
    "clearFilters": "フィルターをクリア",
    "count": "{{total}} 件中 {{shown}} 件",
    "countInactive": " · 無効 {{n}} 件（集計対象外）",
    "selected": "{{n}} 件選択中",
    "setEntity": "エンティティを設定",
    "bulkAria": "選択した人のエンティティ",
    "pick": "— 選択 —",
    "noEntityClear": "エンティティなし（クリア）",
    "apply": "適用",
    "saving": "保存中…",
    "clearSelection": "選択を解除",
    "loading": "読み込み中…",
    "selectAll": "表示中のすべての人を選択",
    "actions": "操作",
    "noEntity": "エンティティなし",
    "selectGroup": "{{name}} のすべての人を選択",
    "expandGroup": "このグループを展開",
    "collapseGroup": "このグループを折りたたむ",
    "expandNamed": "{{name}} を展開",
    "collapseNamed": "{{name}} を折りたたむ",
    "noEntityYet": "エンティティ未設定",
    "notInUse": "· 未使用",
    "groupPerson": "{{n}} 人",
    "groupPeople": "{{n}} 人",
    "selectUser": "{{name}} を選択",
    "partnerTitle": "パートナー会社のアカウント — {{org}}。その会社のサンプルトラックのみが開けます。",
    "partnerChip": "パートナー · {{org}}",
    "deptManager": "{{team}} · マネージャー",
    "viewProfile": "プロフィールを表示",
    "edit": "編集",
    "delete": "削除",
    "noMatch": "フィルターに一致するユーザーはいません。",
    "showOne": "1件を表示",
    "bulkMoved": "{{n}} 件を {{where}} に移動しました。",
    "bulkMovedSome": "{{n}} 件を {{where}} に移動しました · {{m}} 件はすでに所属済みです。",
    "bulkFailed": "エンティティを保存できませんでした。",
    "confirmDelete": "ユーザー「{{name}}」を削除しますか？ 元に戻せません。"
  },
  "edit": {
    "title": "ユーザーを編集",
    "none": "— なし —",
    "notInUseOpt": "（未使用）",
    "switchedOff": "（無効）",
    "mainTitle": "主部門：新しい見積はこの部門に分類され、チームのフィルターもこの部門で開きます。",
    "main": "主部門",
    "manager": "マネージャー",
    "remove": "{{name}} を削除",
    "addDeptAria": "部門を追加",
    "addAnother": "+ 別の部門を追加",
    "addFirst": "+ 部門を追加",
    "noDept": "部門はまだありません。1人が複数の部門に所属でき、マネージャーのチェックは部門ごとに別々に付けられます。",
    "deskHint": "この人が CEO Office でどのデスクのチケットを見られるかを決めます。デスクは、別のデスクのチケットがまったく見えません。CEO Office の権限を持つロールも必要です。",
    "deskNone": "どのデスクにも属していない場合：権限があっても、CEO Office には何も表示されません。",
    "saveChanges": "変更を保存",
    "saving": "保存中…",
    "cancel": "キャンセル"
  },
  "ent": {
    "saved": "保存しました",
    "saveFailed": "保存できませんでした。",
    "nameOf": "{{code}} の名称",
    "kindOf": "{{code}} の種類",
    "inUse": "使用中",
    "save": "保存",
    "saving": "保存中…",
    "added": "{{code}} を追加しました。",
    "addFailed": "エンティティを追加できませんでした。",
    "title": "エンティティ",
    "close": "閉じる",
    "intro": "ユーザーを所属させられる会社と仕入先の一覧です。ユーザー一覧はこれらでグループ化されます。コードは追加後に変更できません。エンティティは削除せず、無効にしてください — すでに所属している人は、誰かが移動するまでそのまま保持されます。",
    "colCode": "コード",
    "colName": "名称",
    "colKind": "種類",
    "colPeople": "人数",
    "colPeopleTitle": "このエンティティの有効なアカウント",
    "colInUse": "使用中",
    "addTitle": "エンティティを追加",
    "codePh": "コード（例：HKOR）",
    "namePh": "名称",
    "newCode": "新しいエンティティのコード",
    "newName": "新しいエンティティの名称",
    "newKind": "新しいエンティティの種類",
    "add": "追加",
    "adding": "追加中…",
    "kindHelinox": "Helinox",
    "kindVendor": "仕入先",
    "kindPartner": "パートナー"
  },
  "page": {
    "title": "ユーザーを編集",
    "loading": "ユーザーデータを読み込み中...",
    "updated": "ユーザーを更新しました。",
    "notSalesRep": "— Sales Rep ではない —",
    "alreadyLinked": "{{name}} — すでに {{user}} に紐づいています",
    "repSuggest": "この名前は Sales Rep の {{name}} と一致しますが、まだアカウントに紐づいていません。",
    "repUse": "{{name}} を紐づける",
    "repUsed": "選択しました — 保存を押すと紐づけられます。",
    "salesRepHint": "このログインをプロジェクトグループの Sales Rep と紐づけ、本人のプロジェクトがポータルのホームに表示されるようにします。「Sales Rep」ロールも付与してください。",
    "deskHint": "この人が CEO Office でどのデスクのチケットを見られるかを決めます。デスクはフィルターではなくアクセス権です。Business デスクの人は Executive のチケットがまったく見えません。「CEO Office」権限を持つロールも必要です — デスクにチェックがないと、そのロールでは空のセクションが表示されます。",
    "update": "更新",
    "updating": "更新中..."
  },
  "profile": {
    "title": "プロフィール",
    "loading": "読み込み中...",
    "noData": "利用できるユーザーデータがありません。",
    "yes": "はい",
    "no": "いいえ",
    "back": "戻る",
    "sending": "送信中...",
    "sendReset": "パスワード再設定メールを送信"
  },
  "reg": {
    "title": "ユーザーを作成",
    "back": "戻る",
    "usernamePh": "例：jane_doe",
    "emailPhPartner": "メールがない場合は空欄",
    "noMailHint": "メールなし：ウェルカムメールは送信できません。アカウントはパスワード <b>1@</b> で始まり、初回サインイン時に本人のパスワードの設定を求められます。",
    "sendWelcome": "ウェルカムメールを送信",
    "create": "ユーザーを作成",
    "creating": "作成中…",
    "cancel": "キャンセル",
    "createdNoMail": "メールなしでユーザーを作成しました。{{name}} にパスワード 1@ をお伝えください — 初回サインイン時に本人が自分のパスワードを設定します（Helinox Partner カード）。",
    "createdMailed": "ユーザーを作成しました。ウェルカムメールを送信しました。",
    "created": "ユーザーを作成しました。",
    "requestNotMarked": "{{msg}}（申請の行を処理済みにできませんでした — 手作業で行ってください）"
  },
  "denied": {
    "title": "アクセスが拒否されました",
    "message": "このページを表示する権限がありません。",
    "home": "← ホームに戻る",
    "relogin": "再ログイン"
  }
};

const dictionary = { ns: 'xUsers', en, ko, vi, zh, fr, ja };

export default dictionary;
